import { createSlice } from "@reduxjs/toolkit";
import { apiCaller } from "../../api/apiCaller";
import { dashboardV3Apis, fasfasDashboardAPis, newDashboardApis } from "../../sharedfiles/EndpointConfig";

// Brands without ClickHouse use the PostgreSQL-backed dashboardv2 endpoints (FasFas, Huztle)
const DASHBOARD_V2_BRAND_IDS = [1294, 1348];
const isFasfasBrand = () => DASHBOARD_V2_BRAND_IDS.includes(Number(localStorage.getItem("brandId")));

export const DashboardV2Slice = createSlice({
    name: "DashboardV2Slice",
    initialState: {
        overallReviewReportV2: [],
        sportsBetReportV2: [],
        sportCasinoNeGameDataV2: [],
        bonusingDataV2: [],
        paymentDataV2: [],
        userActivityV2: [],
        activeTimeDataV2: [],
        topTenWithdrawableUsersV2: [],
        topWinnerLooserListV2: [],
        topTenSportsNeGamesCasinoV2: [],
        prevFormDataV2: {},
        topTenWinnersInPlay: [],
        top10WinnersSports: [],
        top10LosersSports: [],
        top10WinnersCasino: [],
        top10LosersCasino: []
    },
    reducers: {
        setOverallReviewReportV2: (state, action) => {
            state.overallReviewReportV2 = action.payload
        },
        setSportsBetReportV2: (state, action) => {
            state.sportsBetReportV2 = action.payload
        },
        setSportCasinoNeGameDataV2: (state, action) => {
            state.sportCasinoNeGameDataV2 = action.payload
        },
        setBonusingDataV2: (state, action) => {
            state.bonusingDataV2 = action.payload
        },
        setPaymentDataV2: (state, action) => {
            state.paymentDataV2 = action.payload
        },
        setUserActivityV2: (state, action) => {
            state.userActivityV2 = action.payload
        },
        setActiveTimeDataV2: (state, action) => {
            state.activeTimeDataV2 = action.payload
        },
        setTopTenWithdrawableUsersV2: (state, action) => {
            state.topTenWithdrawableUsersV2 = action.payload
        },
        setTopWinnerLooserListV2: (state, action) => {
            state.topWinnerLooserListV2 = action.payload
        },
        setTopTenSportsNeGamesCasinoV2: (state, action) => {
            state.topTenSportsNeGamesCasinoV2 = action.payload
        },
        setPrevFormDataV2: (state, action) => {
            state.prevFormDataV2 = action.payload;
        },
        setTopTenWinnersInPlay: (state, action) => {
            state.topTenWinnersInPlay = action.payload
        },
        setTop10WinnersSports: (state, action) => {
            state.top10WinnersSports = action.payload;
        },
        setTop10LosersSports: (state, action) => {
            state.top10LosersSports = action.payload;
        },
        setTop10WinnersCasino: (state, action) => {
            state.top10WinnersCasino = action.payload;
        },
        setTop10LosersCasino: (state, action) => {
            state.top10LosersCasino = action.payload;
        },
    },
})

export const {
    setOverallReviewReportV2,
    setSportsBetReportV2,
    setSportCasinoNeGameDataV2,
    setBonusingDataV2,
    setPaymentDataV2,
    setUserActivityV2,
    setActiveTimeDataV2,
    setTopTenWithdrawableUsersV2,
    setTopWinnerLooserListV2,
    setTopTenSportsNeGamesCasinoV2,
    setPrevFormDataV2,
    setTopTenWinnersInPlay,
    setTop10WinnersSports,
    setTop10LosersSports,
    setTop10WinnersCasino,
    setTop10LosersCasino
} = DashboardV2Slice.actions;

export const getOverallReviewReportByPeriodV2 = () => (dispatch) => {
    let url = newDashboardApis.getOverallReviewReportByPeriod
    apiCaller(url, "GET").then((res) => {
        if (res.status === 200) {
            dispatch(setOverallReviewReportV2(res.data))
        }
    }).catch(() => dispatch(setOverallReviewReportV2([])))
}

export const getSportsBetsReportV2 = (param) => (dispatch) => {
    let url = isFasfasBrand() ? fasfasDashboardAPis.getSportsBetsReportV2 : dashboardV3Apis.getSportsBetsReportV3
    apiCaller(url, "POST", param).then((res) => {
        if (res.status === 200) {
            dispatch(setSportsBetReportV2(res.data))
        }
    }).catch(() => dispatch(setSportsBetReportV2([])))
}

export const getBetReportByGameTypeV2 = (param) => (dispatch) => {
    let url = isFasfasBrand() ? fasfasDashboardAPis.getBetReportByGameTypeV2 : dashboardV3Apis.getBetReportByGameTypeV3
    apiCaller(url, "POST", param).then((res) => {
        if (res.status === 200) {
            dispatch(setSportCasinoNeGameDataV2(res.data))
        }
    }).catch(() => dispatch(setSportCasinoNeGameDataV2([])))
}

export const getBonusReportV2 = (param) => (dispatch) => {
    let url = isFasfasBrand() ? fasfasDashboardAPis.getBonusReportV2 : dashboardV3Apis.getBonusReportV3
    apiCaller(url, "POST", param).then((res) => {
        if (res.status === 200) {
            dispatch(setBonusingDataV2(res.data))
        }
    }).catch(() => dispatch(setBonusingDataV2([])))
}

export const getPaymnetReportV2 = (param) => (dispatch) => {
    let url = isFasfasBrand() ? fasfasDashboardAPis.getPaymnetReportV2 : dashboardV3Apis.getPaymnetReportV3
    apiCaller(url, "POST", param).then((res) => {
        if (res.status === 200) {
            dispatch(setPaymentDataV2(res.data))
        }
    }).catch(() => dispatch(setPaymentDataV2([])))
}

export const getUserActivityReportV2 = (param) => (dispatch) => {
    let url = isFasfasBrand() ? fasfasDashboardAPis.getUserActivityReportV2 : dashboardV3Apis.getUserActivityReportV3
    apiCaller(url, "POST", param).then((res) => {
        if (res.status === 200) {
            dispatch(setUserActivityV2(res.data))
        }
    }).catch(() => dispatch(setUserActivityV2([])))
}

export const getUserActiveTimesReportByTypeV2 = (param, type) => (dispatch) => {
    let url = newDashboardApis.getUserActiveTimesReportByType(type)
    apiCaller(url, "POST", param).then((res) => {
        if (res.status === 200) {
            dispatch(setActiveTimeDataV2(res.data))
        }
    }).catch(() => dispatch(setActiveTimeDataV2([])))
}

export const getTopTenWithdrawableUsersV2 = (param) => (dispatch) => {
    let url = isFasfasBrand() ? fasfasDashboardAPis.getTopTenWithdrawableUsersV2 : dashboardV3Apis.getTopTenWithdrawableUsersV3
    apiCaller(url, "POST", param).then((res) => {
        if (res.status === 200) {
            dispatch(setTopTenWithdrawableUsersV2(res.data))
        }
    }).catch(() => dispatch(setTopTenWithdrawableUsersV2([])))
}

export const getTopTenWinnerLooserV2 = (param) => (dispatch) => {
    let url = isFasfasBrand() ? fasfasDashboardAPis.getTopTenWinnerLooserV2 : dashboardV3Apis.getTopTenWinnerLooserV3
    apiCaller(url, "POST", param).then((res) => {
        if (res.status === 200) {
            dispatch(setTopWinnerLooserListV2(res.data))
        }
    }).catch(() => dispatch(setTopWinnerLooserListV2([])))
}

export const getTopTenSportsNeGamesCasinoV2 = (param) => (dispatch) => {
    let url = isFasfasBrand() ? fasfasDashboardAPis.getTopSportsGamesReportV2 : dashboardV3Apis.getTopSportsGamesReportV3
    apiCaller(url, "POST", param).then((res) => {
        if (res.status === 200) {
            dispatch(setTopTenSportsNeGamesCasinoV2(res.data))
        }
    }).catch(() => dispatch(setTopTenSportsNeGamesCasinoV2([])))
}

export const getTopTenWinnersInPlay = (param) => (dispatch) => {
    let url = isFasfasBrand() ? fasfasDashboardAPis.getTopTenWinnersInPlayApi : dashboardV3Apis.getTopTenWinnersInPlayApi
    apiCaller(url, "POST", param).then((res) => {
        if (res.status === 200) {
            dispatch(setTopTenWinnersInPlay(res.data))
        }
    }).catch(() => dispatch(setTopTenWinnersInPlay([])))
}

export const getTop10WinnersLosersSports = (param) => (dispatch) => {
    let url = isFasfasBrand() ? fasfasDashboardAPis.getTop10WinnersLosersSports : dashboardV3Apis.getTop10WinnersLosersSports;
    apiCaller(url, "POST", param).then((res) => {
        if (res.status === 200) {
            dispatch(setTop10WinnersSports(res.data));
            dispatch(setTop10LosersSports(res.data));
        }
    }).catch(() => {
        dispatch(setTop10WinnersSports([]));
        dispatch(setTop10LosersSports([]));
    });
};

export const getTop10WinnersCasino = (param) => (dispatch) => {
    let url = isFasfasBrand() ? fasfasDashboardAPis.getTop10WinnersCasino : dashboardV3Apis.getTop10WinnersCasino;
    apiCaller(url, "POST", param).then((res) => {
        if (res.status === 200) {
            dispatch(setTop10WinnersCasino(res.data));
        }
    }).catch(() => dispatch(setTop10WinnersCasino([])));
};

export const getTop10LosersCasino = (param) => (dispatch) => {
    let url = isFasfasBrand() ? fasfasDashboardAPis.getTop10LosersCasino : dashboardV3Apis.getTop10LosersCasino;
    apiCaller(url, "POST", param).then((res) => {
        if (res.status === 200) {
            dispatch(setTop10LosersCasino(res.data));
        }
    }).catch(() => dispatch(setTop10LosersCasino([])));
};


export default DashboardV2Slice.reducer